import { connect } from 'redux-bundler-react';
import PropTypes from 'prop-types';
import React from 'react';

import ArchBaseSelect from '../../molecules/ArchBaseSelect';
import ChefPackage from '../../../models/chef_package';

const ArchChefPackage = ({ chefPackageData, ...rest }) => (
  <ArchBaseSelect
    label="Script Package"
    {...rest}
    options={chefPackageData || []}
    renderValueName={value => value.name}
  />
);

ArchChefPackage.propTypes = {
  facility: PropTypes.instanceOf(ChefPackage),
};

ArchChefPackage.defaultProps = {
  facility: null,
};

export default connect('selectChefPackageData', ArchChefPackage);
